import {TopBannerLogoImageDefaultBox} from "./top-banner-logo-image.default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

export const TopBannerLogoImageBox = styledByTheme(TopBannerLogoImageDefaultBox).apply() ;
